import Icon from 'veui/components/Icon'
import { IconYingxiaotong } from 'dls-icons-vue'

Icon.register('yingxiaotong', IconYingxiaotong)
